module.exports = __webpack_public_path__ + "static/media/MU_Landing_Page_EN_4x5.9f43067b.vtt";